import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { ACCOUNT_API_TRANSLOCO_SCOPE } from './account-api-transloco-scope';
import { AccountCustomizedTexts } from './account-customized-texts';
import { SessionState } from './session';
import { TERMS_AND_PRIVACY_POLICY_LINKS } from './terms-and-privacy-policy-links';

export type AccountCustomizedTextsEnvironment = 'yatta' | 'unknown';

export const FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS: (
  modification: 'pureSignIn' | 'withContinue',
  environment?: AccountCustomizedTextsEnvironment
) => AccountCustomizedTexts = (modification: 'pureSignIn' | 'withContinue', environment?: AccountCustomizedTextsEnvironment) => ({
  oAuth: {
    termsAndPrivacyPolicy: {
      key: ACCOUNT_API_TRANSLOCO_SCOPE + '.accountCustomizedTexts.oAuth.termsAndPrivacyPolicy',
      params: { ...TERMS_AND_PRIVACY_POLICY_LINKS, environment: environment ?? 'unknown' },
      scope: ACCOUNT_API_TRANSLOCO_SCOPE
    }
  },
  signIn: {
    title: () => ({ key: ACCOUNT_API_TRANSLOCO_SCOPE + '.accountCustomizedTexts.signIn.title', params: { modification }, scope: ACCOUNT_API_TRANSLOCO_SCOPE })
  },
  verifyEmail: {
    toContinueInstructions: {
      default: {
        key: ACCOUNT_API_TRANSLOCO_SCOPE + '.accountCustomizedTexts.verifyEmail.toContinueInstructions.default',
        params: { modification },
        scope: ACCOUNT_API_TRANSLOCO_SCOPE
      },
      signIn: { key: ACCOUNT_API_TRANSLOCO_SCOPE + '.accountCustomizedTexts.verifyEmail.toContinueInstructions.signIn', scope: ACCOUNT_API_TRANSLOCO_SCOPE }
    }
  },
  registrationComplete: {
    text: (store: Store) =>
      store.select(SessionState.email).pipe(
        map(email => ({
          key: ACCOUNT_API_TRANSLOCO_SCOPE + '.accountCustomizedTexts.registrationComplete.text',
          params: { emailClass: 'text-p-40 inline-flex max-w-full overflow-hidden', email: email ?? '', emailState: email ? 'set' : 'unset' },
          scope: ACCOUNT_API_TRANSLOCO_SCOPE
        }))
      )
  }
});
